export default [
    "21 20",
    '<path id="Icon" d="M10.4993 4.16699V15.8337M4.66602 10.0003H16.3327" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>']